// 步骤二增减挂钩录入标的信息
<template>
  <div class="container-main" v-loading="Loading">
    <div class="top-title">挂牌申请</div>
    <div class="main">
        <ApplicationSteps  :activeNumber="activeNumber" :titleArray="titleArray" />
        <el-form ref="formRef" :rules="rules" :model="formData" label-width="180px" label-position="left" size="mini">
          <div class="h_bg p50">
            <h3>标的信息</h3>
            <span>带"<span class="redF xing" >*</span>"号为必填项</span>
          </div>
          <div class="m50">
            <el-form-item label="标的名称" prop="name">
              <el-input v-model="formData.name" placeholder="请输入标的名称" :maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="标的位置" prop="address">
              <area-tree v-if="formData.address" style="width: 300px;" v-model="formData.address"></area-tree>
            </el-form-item>
            <el-form-item label="" prop="fullAddress">
              <el-input v-model="formData.fullAddress" placeholder="请输入详细地址（如村、庄等）"></el-input>
            </el-form-item>
            <el-form-item label="标的数量" prop="number">
              <el-input maxlength="13" v-model="formData.number" @keyup.native="changeCode('number')" placeholder="请输入标的数量">
              </el-input>
            </el-form-item>
            <el-form-item label="标的单位" prop="unit">
              <el-input @blur="getUnitNumOpiton()" v-model="formData.unit" placeholder="请输入标的单位"></el-input>
            </el-form-item>
              <el-form-item label="流转期限" prop="transferPeriod">
              <el-input v-model="formData.transferPeriod" placeholder="请输入流转期限" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="流转方式" prop="transferMethod">
              <el-input
                  v-model="formData.transferMethod"
                  placeholder="请输入流转方式"
              ></el-input>
            </el-form-item>
            <el-form-item label="是否存在他项权利人" prop="isOtherRightsHolder">
              <el-radio-group v-model="formData.isOtherRightsHolder">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="他项权利人" v-if="formData.isOtherRightsHolder == 1" prop="otherRightsHolder">
              <el-input v-model="formData.otherRightsHolder" placeholder="请输入他项权利人"></el-input>
            </el-form-item>
            <el-form-item label="他项权利内容" v-if="formData.isOtherRightsHolder == 1" prop="otherRightsContent">
              <el-input v-model="formData.otherRightsContent" placeholder="请输入他项权利内容"></el-input>
            </el-form-item>
            <el-form-item label="标的图">
              <Upload v-model="imgUrl" buttonText="上传" @fileNameEvt="fileNameEvt" :size="true"></Upload>
              <div v-for="(item, index) in formData.imgList" :key="index">
                <div class="lookAddr">
                  <span class="name">{{ item.imgName }}</span>
                  <el-link class="mr20 blueC" :underline="false" v-if="item.imgUrl" :href="item.imgUrl" target="_blank">详情</el-link>
                  <i @click.prevent.stop="formData.imgList.splice(index, 1)" class="el-icon-delete"></i>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="备注">
              <Tinymce-editor  v-model="formData.remark" ></Tinymce-editor>
            </el-form-item>
        </div>
        <div class="h_bg p50">
          <h3>交易信息</h3>
          <span>带"<span class="redF xing">*</span>"号为必填项</span>
        </div>
        <div class="m50">
          <el-form-item label="交易方式" prop="tranferType">
            <el-radio-group v-model="formData.tranferType" @change="formData.amount = ''">
              <el-radio :label="1">网络竞价</el-radio>
              <!-- <el-radio :label="2">协议转让</el-radio>
              <el-radio :label="3">预售</el-radio> -->
            </el-radio-group>
          </el-form-item>
<!--          <el-form-item :label="formData.tranferType == 1 ? '起拍价格' : '标的价格'" prop="amount">-->
<!--            <el-input v-model="formData.amount" @keyup.native="changeCode('amount')" :placeholder="formData.tranferType == 1 ? '请输入起拍价格' : '请输入标的价格'" :maxlength="15" class="half" >-->
<!--            </el-input>-->
<!--            <el-select v-model="formData.amountUnit"  class="half" >-->
<!--              <el-option label="元" :value="'1'" placeholder="请选择"></el-option>-->
<!--              <el-option label="万元" :value="'2'"></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
          <el-form-item label="出价方式" prop="bidType">
            <el-radio-group
                v-model="formData.bidType"
            >
              <el-radio label="0">总价</el-radio>
              <el-radio label="1">单价</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="flex-row">
            <el-form-item :label="formData.tranferType == 1 ? '起拍价格' : '标的价格'" prop="listingPrice">
              <el-input :placeholder="
                formData.tranferType == 1 ? '请输入起拍价格' : '请输入标的价格'
              " v-model="formData.listingPrice" maxlength="9" style="width: 200px;margin-right:10px;">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-select size="mini" v-model="formData.unitNum" v-if="formData.bidType==='1'" class="half" placeholder="请选择数量单位">
              <el-option v-for="(item,index) in unitNumOption" :label="item" :value="item" :key="index"></el-option>
            </el-select>
            <el-select size="mini" v-model="formData.unitTime" v-if="formData.bidType==='1'" class="half" placeholder="请选择时间单位">
              <el-option value="1" label="年"></el-option>
              <el-option value="2" label="季度"></el-option>
              <el-option value="3" label="月"></el-option>
              <el-option value="0" label="无"></el-option>
            </el-select>
          </div>
          <el-form-item label="付款方式" prop="paymentMethod">
            <el-input
                v-model="formData.paymentMethod"
                placeholder="请输入付款方式"
                maxlength="200"
            ></el-input>
          </el-form-item>
        </div>
        <div class="h_bg p50">
          <h3>标的物所属主体信息</h3>
          <span>带"<span class="redF xing">*</span>"号为必填项</span>
        </div>
        <div class="m50">
          <el-form-item label="主体类型" prop="mainPartIdentityType">
            <el-radio-group v-model="formData.mainPartIdentityType" @change="restMainPartInfo()">
<!--              <el-radio :label="1">企业</el-radio>-->
<!--              <el-radio :label="2">组织</el-radio>-->
<!--              <el-radio :label="3">个人</el-radio>-->
              <el-radio label="01">企事业单位</el-radio>
              <el-radio label="02">自然人</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="转让方类型" prop="transferType">
            <el-select v-model="formData.transferType" placeholder="请选择转让方类型">
              <el-option key="01" value="01" label="国有企业"></el-option>
              <el-option key="02" value="02" label="行政事业"></el-option>
              <el-option key="99" value="99" label="其他"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="formData.mainPartIdentityType == '01' ? '企业名称'  :'姓名'" prop="mainPartIdentityName">
            <el-input v-model="formData.mainPartIdentityName"  placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="统一信用代码" prop="mainPartCreditCode" v-if="formData.mainPartIdentityType=='01'">
            <el-input v-model="formData.mainPartCreditCode"  placeholder="请输入统一信用代码"></el-input>
          </el-form-item>
          <el-form-item label="注册地址" prop="mainPartRegistAddrss" v-if="formData.mainPartIdentityType=='01'">
            <el-input v-model="formData.mainPartRegistAddrss"  placeholder="请输入注册地址"></el-input>
          </el-form-item>
          <el-form-item label="法定代表人" prop="mainPartLegalName" v-if="formData.mainPartIdentityType=='01'">
            <el-input v-model="formData.mainPartLegalName"  placeholder="请输入法定代表人"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="mainPartIdNumber" v-if="formData.mainPartIdentityType=='02'">
            <el-input v-model="formData.mainPartIdNumber"  placeholder="请输入身份证号" :maxlength="18"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="mainPartContactPerson" v-if="formData.mainPartIdentityType=='01'">
            <el-input v-model="formData.mainPartContactPerson"  placeholder="请输入联系人" :maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="mainPartContactNumber">
            <el-input v-model="formData.mainPartContactNumber" maxlength="11"  placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="mainPartContactAddress" v-if="formData.mainPartIdentityType=='01'">
            <el-input v-model="formData.mainPartContactAddress"  placeholder="请输入联系地址"></el-input>
          </el-form-item>
          <el-form-item label="企业性质" prop="companyProperties" v-if="formData.mainPartIdentityType=='01'">
            <el-select v-model="formData.companyProperties" placeholder="请选择企业性质（经济类型）">
              <el-option
                  v-for="item in companyPropertiesList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业类型" prop="companyType" v-if="formData.mainPartIdentityType=='01'">
            <el-select v-model="formData.companyType" placeholder="请选择企业类型">
              <el-option
                  v-for="item in companyTypeList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经济规模" prop="economicScale" v-if="formData.mainPartIdentityType=='01'">
            <el-select v-model="formData.economicScale" placeholder="请选择经济规模">
              <el-option
                  v-for="item in economicScaleList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属行业" prop="companyIndustryCode" v-if="formData.mainPartIdentityType=='01'">
            <el-cascader
                style="width: 300px;"
                clearable
                filterable
                v-model="formData.companyIndustryCode"
                placeholder="请选择所属行业"
                :options="companyIndustryCodeList"
                :props="{ label: 'industryName',value: 'industryCode',children: 'subsetList' }"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="资金来源" prop="sourceFund" v-if="formData.mainPartIdentityType=='02'">
            <el-select v-model="formData.sourceFund" placeholder="请选择资金来源">
              <el-option
                  v-for="item in sourceFundList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div>
        <div class="h_bg p50">
          <h3>所需资料</h3>
          <span>（支持上传pdf或图片格式）</span>
        </div>
        <el-form class="form">
          <el-row class="mt20">
            <el-col v-for="item of roleFileList" :key="item.fileNameKey">
              <div v-if="item.maxNumber == 1">
                <el-form-item :class="{ actives: item.isRequire }" :label="item.fileName" label-width="530px" style="margin-bottom: 0">
                  <OneUpload style="display: inline-block; margin-left: 50px" :fileFuther="item" :downFlag="downFlag" />
                </el-form-item>
              </div>
              <div v-else>
                <el-form-item :class="{ actives: item.isRequire }" :label="`${item.fileName}(可上传多份)`" label-width="530px" style="margin-bottom: 0">
                  <ListUpload style="display: inline-block; margin-left: 50px" :fileFuther="item" :downFlag="downFlag" />
                </el-form-item>
              </div>
            </el-col>
            <div>
              <Upload v-model="otherImgUrl" buttonText="上传其他资料" @fileNameEvt="fileNameOtherEvt" :size="true" :accept="'image/*,.pdf'"></Upload>
              <div v-for="(item, ind) of formData.otherFileList" :key="ind">
                <el-form-item :label="item.fileName" label-width="390px" style="margin-bottom: 0">
                  <OtherOneUpload style="display: inline-block; margin-left: 50px" :fileFuther="item" :index="ind" @delOtherImg="delOtherImg()" />
                </el-form-item>
              </div>
            </div>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 60px auto 30px;">
        <el-form class="form">
          <div v-for="item in formData.bidNoticDetail" :key="item.label">
            <el-form-item :label="item.labelName" label-width="150px" label-position="left" size="mini">
              <Tinymce-editor  v-model="item.value" ></Tinymce-editor>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <!-- <AgreeDialog @checkAgree="checkAgreeEvt" @agreementName="getAgreeName"></AgreeDialog> -->
    </div>
    <div class="btn" style="text-align: right">
      <el-button @click="$router.go(-1)">上一步</el-button>
      <el-button @click="saveDisable && save()">保存</el-button>
      <el-button class="sumbit" @click="sumbitDisable && sumbitEvt()">提交</el-button>
    </div>
  </div>
</template>
<script>
import OneUpload from '@/components/DataUpload/OneUpload.vue';
import ListUpload from '@/components/DataUpload/ListUpload.vue';
import ApplicationSteps from '@/components/ApplicationSteps'; // 步骤组件
import {
  addrOptions,
  companyPropertiesList,
  companyTypeList,
  economicScaleList,
  forestOptions, sourceFundList
} from '@/common/options.js';
import Upload from '@/components/Upload/UpLoad.vue';
import AreaTree from './components/AreaTree';
import OtherOneUpload from '@/components/DataUpload/OtherOneUpload.vue';
import AgreeDialog from '@/components/agreeDialog'
import TinymceEditor from '@/components/TinymceEditor'
export default {
  components: {
    ApplicationSteps,
    OneUpload,
    ListUpload,
    Upload,
    AreaTree,
    OtherOneUpload,
    AgreeDialog,
    TinymceEditor,
  },
  data() {
    const validateDecimal2 = (rule,value,callback) =>{
      let reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
      if(!value){
        callback(new Error('请输入'))
      }else if(!reg.test(value)){
        callback(new Error('请输入正数，最多可保留2位小数'))
      }else{
        callback();
      }
    };
    const validateIdNum = (rule,value,callback) =>{
      const reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if(!value){
        callback(new Error('请输入'))
      }else if(!reg.test(value)){
        callback(new Error('请输入正确的身份证号码'))
      }else{
        callback();
      }
    }
    const validateDecimal4 = (rule,value,callback) =>{
      let reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,4})))$/
      if(value&&!reg.test(value)){
        callback(new Error('请输入正数，最多可保留4位小数'))
      }else{
        callback();
      }
    };
    const checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入联系电话"));
      }
      if (!/^\d{11}$/.test(value)) {
        callback(new Error("请输入正确的11位联系电话"));
      }
      callback();
    };
    return {
      companyIndustryCodeList: [],
      companyPropertiesList,
      companyTypeList,
      economicScaleList,
      sourceFundList,
      unitNumOption: [], //起拍价格数量单位选项
      saveDisable: true,
      sumbitDisable: true,
      activeNumber: 2,
      titleArray: ['选择业务类型', '录入标的信息', '确认挂牌'],
      projectSortOptions: addrOptions,
      projectRegionOptions: forestOptions,
      rules: {
        transferType: [{ required: true, message: '请选择', trigger: 'change' }],
        companyProperties: [{ required: true, message: '请选择', trigger: 'change' }],
        companyType: [{ required: true, message: '请选择', trigger: 'change' }],
        economicScale: [{ required: true, message: '请选择', trigger: 'change' }],
        companyIndustryCode: [{ required: true, message: '请选择', trigger: 'change' }],
        sourceFund: [{ required: true, message: '请选择', trigger: 'change' }],
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        isOtherRightsHolder: [{ required: true, message: '请输入', trigger: 'blur' }],
        otherRightsHolder: [{ required: true, message: '请输入', trigger: 'blur' }],
        transferPeriod: [{ required: true, message: '请输入', trigger: 'blur' }],
        otherRightsContent: [{ required: true, message: '请输入', trigger: 'blur' }],
        address: [{ required: true, message: '请输入', trigger: 'change' }],
        fullAddress: [{ required: true, message: '请输入', trigger: 'blur' }],
        otherContractingMode: [ { required: true, message: '请输入', trigger: 'blur' }],
        tranferType: [{ required: true, message: '请输入', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入', trigger: 'blur' }],
        unit: [{ required: true, message: '请输入', trigger: 'blur' }],
        number:  [{ required: true, trigger: "blur",validator: validateDecimal4 }],
        mainPartIdentityType: [{ required: true, message: '请输入', trigger: 'blur' }],
        mainPartIdentityName: [{ required: true, message: '请输入', trigger: 'blur' }],
        mainPartCreditCode: [{ required: true, message: '请输入', trigger: 'blur' }],
        mainPartRegistAddrss: [{ required: true, message: '请输入', trigger: 'blur' }],
        mainPartLegalName: [{ required: true, message: '请输入', trigger: 'blur' }],
        mainPartIdNumber: [{ required: true, trigger: 'blur', validator: validateIdNum }],
        mainPartContactPerson: [{ required: true, message: '请输入', trigger: 'blur' }],
        mainPartContactNumber: [{ required: true, validator: checkPhone, trigger: 'blur' }],
        mainPartContactAddress: [{ required: true, message: '请输入', trigger: 'blur' }],
        transferMethod: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        paymentMethod: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        bidType: [
          { required: true, message: '请输入', trigger: 'change' },
        ],
        listingPrice:[
          { required: true, trigger: 'blur', validator: validateDecimal2 },
        ],
      },
      formData: {
        unitTime: '',
        unitNum: '',
        listingPrice: '', //起拍价格
        bidType: '0', //出价方式
        paymentMethod: "", //付款方式
        transferMethod: "", //流转方式
        areaConfigId: '',
        name: '', //标的名称
        isOtherRightsHolder: 2, //是否存在他项权利人
        otherRightsHolder: '', //他项权利人
        otherRightsContent: '', //他项权利内容
        location: '', //所在地区 总地址
        tranferType: 1, //交易方式
        amount: '', //标的价格
        fileList: [],
        transferPeriod: '', //流转期限
        address: '',
        fullAddress: '',
        imgList: [], //标的图
        otherFileList: [], // 其他文件  fileName 和 fileUrl
        businessType: '7', //自定义标的类型
        unit:'', //标的单位
        number:'', //标的数量
        mainPartIdentityType: '01',  // 01	企事业单位 02	自然人 //主体身份类型  1企业 2组织  3个人
        mainPartIdentityName:'',
        mainPartCreditCode: '',
        mainPartRegistAddrss:'',
        mainPartLegalName:'',
        mainPartContactPerson: '',
        mainPartContactNumber: '',
        mainPartContactAddress:'',
        mainPartIdNumber: '',
        transferType: '', //转让方类型
        companyProperties: '', //企业性质（经济类型）
        companyType: '', //企业类型
        economicScale: '', //经济规模
        sourceFund: '', //资金来源
        companyIndustryCode: [], //所属行业
        listingMainPart:{
          transferType: '', //转让方类型
          companyProperties: '', //企业性质
          companyType: '', //企业类型
          economicScale: '', //经济规模
          companyIndustryCode: '', //所属行业
          sourceFund: '', //资金来源
          identityType: '',  //主体身份类型  1企业 2组织  3个人
          name: '',  //企业名称/组织名称/姓名
          creditCode: '',  //统一信用代码
          registAddrss: '',  //注册地址
          legalName: '',  //法定代表人
          contactPerson: '',  //联系人
          contactNumber: '',  //联系电话
          contactAddress: '',  //联系地址
          idNumber: '',  //身份证号  ;
        },
        amountUnit:'1',
        remark:'',
        bidNoticDetail:[]
      },
      imgUrl: '', // 标的图的url
      fileName: '', //标的图的name
      otherImgUrl: '', // 其他资料的url
      otherFileName: '', //其他资料的name
      downFlag: true,
      roleFileList: [],
      Loading: false,
      // pickerOptions: {
      //   disabledDate: (time) => {
      //     return this.dealDisabledDate(time);
      //   },
      // },
      agreementName:'',
      checkAgree: false,

    };
  },
  computed: {
    storeArea() {
      return this.$store.state.cityArea;
    },
  },
  watch: {
    imgUrl: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.imgList.push({
            imgUrl: newVal,
            imgName: this.fileName,
          });
          this.imgUrl = '';
          this.fileName = '';
        }
      },
    },
    otherImgUrl: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.otherFileList.push({
            fileUrl: newVal,
            fileName: this.otherFileName,
          });
          this.otherImgUrl = '';
          this.otherFileName = '';
        }
      },
    },
  },
  methods: {
    getCompanyIndustryCodeList(){
      this.$api.user.getSelectIndustryList().then(res=>{
        if(res.code===1000){
          this.companyIndustryCodeList = res.data
        }
      })
    },
    //起拍价格数量单位选项
    getUnitNumOpiton(){
      this.formData.unitNum = ''
      if(this.formData.unit.trim()){
        this.unitNumOption = [
          this.formData.unit,
          '无'
        ]
      }else {
        this.unitNumOption = [
          '无'
        ]
      }
    },
    restMainPartInfo(){
      this.formData.mainPartIdentityName = ''  //企业名称/组织名称/姓名
      this.formData.mainPartCreditCode = '',  //统一信用代码
      this.formData.mainPartRegistAddrss = '',  //注册地址
      this.formData.mainPartLegalName = '',  //法定代表人
      this.formData.mainPartContactPerson = '' //联系人
      this.formData.mainPartContactNumber = ''  //联系电话
      this.formData.mainPartContactAddress = ''  //联系地址
      this.formData.mainPartIdNumber = ''  //身份证号  ;
      this.formData.transferType = '' //转让方类型
      this.formData.companyProperties = '' //企业性质
      this.formData.companyType = '' //企业类型
      this.formData.economicScale = '' //经济规模
      this.formData.companyIndustryCode = [] //所属行业
      this.formData.sourceFund = '' //资金来源
    },
    delOtherImg(v) {
      if (this.formData.otherFileList.length > 0) {
        this.formData.otherFileList.splice(v, 1);
      }
    },
    fileNameOtherEvt(v) {
      this.otherFileName = v;
    },
    fileNameEvt(v) {
      this.fileName = v;
    },
    async getAreaCodeById() {
      await this.$api.user.getAreaCodeById({ areaConfigId: this.storeArea.areaConfigId }).then((res) => {
        this.formData.address =res.data.provinceName +'/' +res.data.cityName +'/' +(res.data.areaName ? res.data.areaName : '/');
      });
    },
    // dealDisabledDate(time) {
    //   return time.getTime() < Date.now() - 8.64e7;
    // },
    save() {
      if (!this.formData.address || this.formData.address =='广西壮族自治区/崇左市/')  {return this.$message.error(`请选择地区`); }
      this.Loading = true;
      this.sumbitDisable = false;
      let directionalFinancingFiles = [];
      this.roleFileList.forEach((item) => {
        const obj = {
          appendixType: item.appendixType,
          fileName: item.fileName,
          fileUrl: [],
          fileType: item.fileType,
          canDownload: item.canDownload,
          downloadUrl: item.downloadUrl,
          maxNumber: item.maxNumber,
          isRequire: item.isRequire,
        };
        if (item.maxNumber == 1 && item.fileList[0]) {
          obj.fileUrl.push(item.fileList[0].fileUrl || '');
        } else {
          item.fileList.forEach((i) => {
            obj.fileUrl.push(i.fileUrl || '');
          });
        }
        directionalFinancingFiles.push(obj);
      });
      this.formData.fileList = directionalFinancingFiles;
      this.formData.areaConfigId = this.storeArea.areaConfigId;
      this.formData.location = this.formData.address + (this.formData.fullAddress ? ('/' + this.formData.fullAddress) : '');
      const a = this.formData.address.split('/');
      if(a[0])this.$set(this.formData, 'province', a[0]);
      if(a[1])this.$set(this.formData, 'city', a[1]);
      if(a[2])this.$set(this.formData, 'county', a[2]);
      if(a.length>3){
        this.$set(this.formData, 'township', a[3])
        this.$set(this.formData, 'village', a[4])
      }
      this.formData.listingMainPart.identityType = this.formData.mainPartIdentityType
      this.formData.listingMainPart.name = this.formData.mainPartIdentityName
      this.formData.listingMainPart.creditCode = this.formData.mainPartCreditCode
      this.formData.listingMainPart.registAddrss = this.formData.mainPartRegistAddrss
      this.formData.listingMainPart.legalName = this.formData.mainPartLegalName
      this.formData.listingMainPart.contactPerson = this.formData.mainPartContactPerson
      this.formData.listingMainPart.contactNumber = this.formData.mainPartContactNumber
      this.formData.listingMainPart.contactAddress = this.formData.mainPartContactAddress
      this.formData.listingMainPart.idNumber = this.formData.mainPartIdNumber
      this.formData.listingMainPart.transferType = this.formData.transferType
      this.formData.listingMainPart.companyProperties = this.formData.companyProperties
      this.formData.listingMainPart.companyType = this.formData.companyType
      this.formData.listingMainPart.economicScale = this.formData.economicScale
      if(this.formData.mainPartIdentityType=='01'){
        this.formData.listingMainPart.companyIndustryCode = this.formData.companyIndustryCode[1]
      }
      this.formData.listingMainPart.sourceFund = this.formData.sourceFund
      const param = JSON.parse(JSON.stringify(this.formData))
      this.$api.my.saveChangeLink(param).then((res) => {
        if (res.code == 1000) {
          this.$message.success('保存成功');
          setTimeout(() => {
            this.$router.push({ name: 'MyApplyList' });
          }, 1500);
        } else {
          this.sumbitDisable = true;
        }
      }).catch((error) => {
        this.sumbitDisable = true;
      }).finally(() => {
        setTimeout(() => {
          this.Loading = false;
        }, 1400);
      });
    },
    //获取模板
    getBidNoticeTemplate(){
      this.Loading = true;
      this.$api.my.getBidNoticeTemplate({businessType: 7}).then((res) => {
        if (res.code == 1000) {
          if(res.data.bidNoticDetail && res.data.bidNoticDetail.length){
            this.formData.bidNoticDetail = res.data.bidNoticDetail
          }
        }
      }).catch((error) => {
      }).finally(() => {
        this.Loading = false;
      });
    },
    sumbitEvt() {
      this.$refs.formRef.validate((v) => {
        if (v) {
          if(this.formData.bidType==1){
            if((!this.formData.unitNum&&!this.formData.unitTime)||(this.formData.unitNum==='无'&&this.formData.unitTime==='0')||
                (!this.formData.unitNum&&this.formData.unitTime==='0')||(this.formData.unitNum==='无'&&!this.formData.unitTime)){
              return this.$message.error(`${this.formData.tranferType == 1 ? '起拍价格' : '标的价格'}数量单位与时间单位，至少填写一个`)
            }
          }
          // if (this.agreementName && !this.checkAgree) return this.$message.error(`请阅读并勾选《${this.agreementName}》`);
          const check = this.checkFileAddr(this.roleFileList);
          let directionalFinancingFiles = [];
          if (check) {
            this.$confirm('确认提交?', '提示', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.Loading = true;
              this.saveDisable = false;
              this.roleFileList.forEach((item) => {
                const obj = {
                  appendixType: item.appendixType,
                  fileName: item.fileName,
                  fileUrl: [],
                  fileType: item.fileType,
                  canDownload: item.canDownload,
                  downloadUrl: item.downloadUrl,
                  maxNumber: item.maxNumber,
                  isRequire: item.isRequire,
                };
                if (item.maxNumber == 1 && item.fileList[0]) {
                  obj.fileUrl.push(item.fileList[0].fileUrl || '');
                } else {
                  item.fileList.forEach((i) => {
                    obj.fileUrl.push(i.fileUrl || '');
                  });
                }
                directionalFinancingFiles.push(obj);
              });
              this.formData.fileList = directionalFinancingFiles;
              this.formData.areaConfigId = this.storeArea.areaConfigId;
              this.formData.location = this.formData.address + '/' + this.formData.fullAddress;
              const a = this.formData.address.split('/');
              this.$set(this.formData, 'province', a[0]);
              this.$set(this.formData, 'city', a[1]);
              this.$set(this.formData, 'county', a[2]);
              if(a.length>3){
                this.$set(this.formData, 'township', a[3])
                this.$set(this.formData, 'village', a[4])
              }
              this.formData.listingMainPart.identityType = this.formData.mainPartIdentityType
              this.formData.listingMainPart.name = this.formData.mainPartIdentityName
              this.formData.listingMainPart.creditCode = this.formData.mainPartCreditCode
              this.formData.listingMainPart.registAddrss = this.formData.mainPartRegistAddrss
              this.formData.listingMainPart.legalName = this.formData.mainPartLegalName
              this.formData.listingMainPart.contactPerson = this.formData.mainPartContactPerson
              this.formData.listingMainPart.contactNumber = this.formData.mainPartContactNumber
              this.formData.listingMainPart.contactAddress = this.formData.mainPartContactAddress
              this.formData.listingMainPart.idNumber = this.formData.mainPartIdNumber
              this.formData.listingMainPart.transferType = this.formData.transferType
              this.formData.listingMainPart.companyProperties = this.formData.companyProperties
              this.formData.listingMainPart.companyType = this.formData.companyType
              this.formData.listingMainPart.economicScale = this.formData.economicScale
              if(this.formData.mainPartIdentityType=='01'){
                this.formData.listingMainPart.companyIndustryCode = this.formData.companyIndustryCode[1]
              }
              this.formData.listingMainPart.sourceFund = this.formData.sourceFund
              const param = JSON.parse(JSON.stringify(this.formData))
              this.$api.my.submitChangeLink(param).then((res) => {
                if (res.code == 1000) {
                  this.$message.success('提交成功');
                  setTimeout(() => {
                    this.$router.push({ name: 'PropertyListingApplication',query: { activeNumber: 3} });
                  }, 1500);
                } else {
                  this.saveDisable = true;
                }
              }).catch((error) => {
                this.saveDisable = true;
              }).finally(() => {
                setTimeout(() => {
                  this.Loading = false;
                }, 1400);
              });
            }).catch(() => {});
          }
        }
      });
    },
    checkFileAddr(list) {
      return (
        list && list.every((item) => {
          if (item.isRequire && item.fileList.length < 1) {
            this.$message.error(`请将《${item.fileName}》的相关资料上传完善`);
            return false;
          } else {
            return true;
          }
        })
      );
    },
    // 获取流程需要的文件 农村
    async getProcessFiles() {
      this.roleFileList = [];
      await this.$api.my.getProcessFiles({ generatePosition: 10, role: 'listing-person', listingMode: 12}).then((res) => {
        if (res.code === 1000) {
          const fileListData = res.data;
          fileListData.forEach((item, index) => {
            this.$set(item, 'status', false);
            item.fileList = [];
          });
          this.roleFileList = fileListData;
        }
      }).catch((err) => {});
    },
    changeCode(name) {
      this.$nextTick(() => {
        if (this.formData[`${name}`] != null) {
          this.formData[`${name}`] = this.formData[`${name}`].replace(/[^\d.]/g,'');
        }
      });
    },
    getAgreeName(v){
      this.agreementName = v
    },
    checkAgreeEvt(v){
      this.checkAgree = v
    }
  },
  async created() {
    await this.getAreaCodeById();
    await this.getProcessFiles();
    await this.getBidNoticeTemplate();
    this.getCompanyIndustryCodeList()
    this.getUnitNumOpiton()
  },
};
</script>
<style lang="scss" scoped>
.container-main {
  width: 1080px;
  margin: 50px auto 0;
  background: #fff;
  width: 1200px;
  padding: 30px;
  .main {
    margin: 0 97px;
  }
  .el-form {
    .el-form-item {
      .el-input,
      .el-select {
        width: 300px;
        /deep/ input {
          height: 30px;
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
          border: 1px solid rgba(240, 240, 240, 1);
          padding: 9px 10px;
        }
      }
    }
  }
  .form {
    .actives {
      /deep/.el-form-item__label::before {
        content: '*';
        display: inline-block;
        vertical-align: middle;
        color: #f56c6c;
        margin-right: 4px;
        font-size: 20px;
      }
    }
  }
  .flex-info{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 10px 0;
    .el-input:nth-of-type(1){
      width: 150px;
    }
    .el-input:nth-of-type(2){
      width: 300px;
      margin: 0 15px 0 30px;
    }
  }
  .activesA  {
    color: #f56c6c;
    font-size: 16px;
    margin-right: 5px;
  }
  .activesWhite  {
    color: #fff;
    font-size: 16px;
    margin-right: 5px;
  }
}
</style>
